<template>
    <div>
        <card>
            <template v-slot:header>
                    <h4 class="d-inline">تنـظیـمـات تیکت</h4>
                    <hr />
            </template>
            <template v-slot:content>
                <Tab :tab="Tablist">
                    <template v-slot:content0>
                        <div class="row">
                            <div class="col-md-8 col-12">
                                <small id="LblUserId" >امضا برای نمایش در تیکت ها</small>
                                <textarea @keypress="$ValidPersian($event, 250)" rows="3" type="text" id="Des" class="form-control" v-model="DataSignature" ></textarea>     
                            </div>
                            <div class="col-md-3 col-12 mt-4">
                                <button  id="SeveData" type="submit" class="btn btn-success mr-1" dir="ltr" @click="Savedata">ثبت امضا </button>
                            </div>
                        </div>
                    </template>
                    <template v-slot:content1>
                       <setting-ticket></setting-ticket>
                    </template>
                </Tab>
            </template>
        </card>
    </div>
</template>
<script>
import Tab from '@/components/Tab/Tab.vue'
import Card from '@/components/Card/Card.vue'
import SettingTicket from './SettingTicket.vue'
export default {
  components: { Card,Tab,SettingTicket },
    data(){
        return {
            DataSignature:'',
            Tablist: [
                { header: 'پانویس تیکت', active: this.activeTab == 0 ,visibility:false},
                { header: 'تنظیمات دیگر', active: this.activeTab == 1 ,visibility:true}
            ],
        }
        
    },
    methods:{
        Savedata(){
            var DataAxiosPost= {
                ArryfildValue: {},
                Method: 'post',
                Action: 'TicketSignature',
                Token: this.$session.get('Token'),
                From: 'Body',
            };
            DataAxiosPost.ArryfildValue.TblUserId=this.$session.get("UserInfo").tblUserId
            DataAxiosPost.ArryfildValue.Signature=this.DataSignature
            DataAxiosPost.ArryfildValue.TblUserGrpIdInsert=this.$session.get("UserInfo").tblUserGrpId
            DataAxiosPost.ArryfildValue.TblUserGrpIdLastEdit=this.$session.get("UserInfo").tblUserGrpId
            this.$PostData(DataAxiosPost).then((data) => {
                if(data.status="Ok"){
                    this.$toasted.success('امضا با موفقیت ایجاد شد', {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                            },
                        },
                        })
                }
            });
        },
    },
    mounted(){
        var DataAxiosPost= {
                ArryfildValue: {},
                Method: 'post',
                Action: 'TicketSignature/Index',
                Token: this.$session.get('Token'),
                From: 'Body',
            };
            DataAxiosPost.ArryfildValue.tblUserId=this.$session.get("UserInfo").tblUserId
            
            this.$PostData(DataAxiosPost).then((data) => {
                if(data!=null){
                    this.DataSignature=data.Signature==null?'':data.Signature

                }else{
                    this.DataSignature=''
                }
            })
    },
    created() {

    }
}
</script>
<style scoped>

</style>